import { Form } from "antd";
import styled from "styled-components";

export const StyledFormPhoneNumber = styled(Form)`
  width: 100%;

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 16px;
  }
  .ant-select {
    height: 58px !important;
  }
`;

export const StyledFormPhoneNumberGroup = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-bottom: 16px;

  .ant-form-item {
    margin-bottom: 0px !important;
  }
  .ant-select {
    .ant-select-selector {
      border-radius: 8px 8px 0px 0px;
      input {
        height: 100% !important;
      }
    }
  }

  .ant-input {
    border-radius: 0px 0px 8px 8px;
  }
  .ant-input-group-addon {
    padding: 0px;
    border-radius: 0px 0px 0px 8px;
    width: 80px;
  }
  .prefix {
    border-radius: 0px 0px 0px 8px !important;
  }
`;
